<a [href]="'mailto:' + address">{{ text || address }}</a>